import React from "react";
import Card from "react-bootstrap/Card";
import { Swiper, SwiperSlide } from "swiper/react";
import Brand1 from "../../assets/images/brand1.png";
import Brand2 from "../../assets/images/brand2.png";
import Brand3 from "../../assets/images/brand3.png";
import Brand4 from "../../assets/images/brand4.png";
import Brand5 from "../../assets/images/brand5.png";

const Brand = () => {
  return (
    <div className="brand">
      <div className="container">
        <div className="card-container d-flex justify-content-center align-content-center">
          <Swiper
            slidesPerView={5}
            slidesPerColumn={2}
            spaceBetween={30}
            loop={true}
            autoplay={{ delay: 8000, disableOnInteraction: false }}
          >
            <SwiperSlide>
              <div className="card-content">
                <Card.Img variant="top" src={Brand1} />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              {" "}
              <div className="card-content">
                <Card.Img variant="top" src={Brand2} />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="card-content">
                <Card.Img variant="top" src={Brand3} />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="card-content">
                <Card.Img variant="top" src={Brand4} />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="card-content">
                <Card.Img variant="top" src={Brand5} />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Brand;
